// extracted by mini-css-extract-plugin
export var info = "style-module--info--73e00";
export var list = "style-module--list--79783";
export var speakers = "style-module--speakers--b2494";